/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_cat_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. It's completely free, needs no signup, and runs entirely in your browser.`)
};

const es_uc_cat_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. Es completamente gratuito, no requiere registro y se ejecuta completamente en tu navegador.`)
};

const de_uc_cat_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Er ist vollkommen kostenlos, erfordert keine Anmeldung und läuft komplett in Ihrem Browser.`)
};

const nl_uc_cat_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Het is volledig gratis, vereist geen registratie en wordt volledig in uw browser uitgevoerd.`)
};

const fr_uc_cat_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. C'est complètement gratuit, ne nécessite aucune inscription, et s'exécute entièrement dans votre navigateur.`)
};

const it_uc_cat_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. È completamente gratuito, non richiede iscrizione e viene eseguito interamente nel tuo browser.`)
};

const pt_br2_uc_cat_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. É completamente gratuito, não requer inscrição e é executado inteiramente no seu navegador.`)
};

const pt_uc_cat_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. É completamente gratuito, não requer registo e executa inteiramente no seu navegador.`)
};

const ja_uc_cat_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。完全に無料で、サインアップが不要で、ブラウザで完全に動作します。`)
};

const zh_uc_cat_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_cat_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_cat_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_cat_faq2_a", locale)
	if (locale === "en") return en_uc_cat_faq2_a(inputs)
	if (locale === "es") return es_uc_cat_faq2_a(inputs)
	if (locale === "de") return de_uc_cat_faq2_a(inputs)
	if (locale === "nl") return nl_uc_cat_faq2_a(inputs)
	if (locale === "fr") return fr_uc_cat_faq2_a(inputs)
	if (locale === "it") return it_uc_cat_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_uc_cat_faq2_a(inputs)
	if (locale === "pt") return pt_uc_cat_faq2_a(inputs)
	if (locale === "ja") return ja_uc_cat_faq2_a(inputs)
	return zh_uc_cat_faq2_a(inputs)
};